/* eslint-disable import/extensions */

import axios from 'axios';

// ======================
// TaxAcc Token Management (dedicated to taxapi)
// ======================

const TAXACC_STORAGE_KEY = 'taxapi';

export function getTaxAccToken() {
  try {
    const item = localStorage.getItem(TAXACC_STORAGE_KEY);
    if (!item) return null;
    return JSON.parse(item);
  } catch (e) {
    console.warn('Failed to parse taxapi token', e);
    return null;
  }
}

export function saveTaxAccToken(tokenObj) {
  try {
    console.log('Saving taxapi token', tokenObj);

    localStorage.setItem(TAXACC_STORAGE_KEY, JSON.stringify(tokenObj));
  } catch (e) {
    console.warn('Failed to save taxapi token', e);
  }
}

export function clearTaxAccToken() {
  localStorage.removeItem(TAXACC_STORAGE_KEY);
}

// ======================
// Core API Functions
// ======================

const TAX_ACC_API_URL = 'https://system.taxacc.mn:8035';

function isTokenExpired(token) {
  return !token || !token.expires_at || Date.now() >= token.expires_at;
}

async function refreshTokenUsingJwt() {
  const taxJwt = localStorage.getItem('taxjwt');

  if (!taxJwt || taxJwt.trim() === '') {
    return {
      state: false,
      message: 'taxjwt байхгүй байна. Нэвтрэх шаардлагатай.',
    };
  }

  try {
    // Critical fix: send {} as JSON body + proper Content-Type
    const response = await axios.post(
      `${TAX_ACC_API_URL}/get_token_jwt`,
      {}, // explicitly send empty JSON object
      {
        headers: {
          Authorization: `Bearer ${taxJwt}`,
          'Content-Type': 'application/json', // required
          Accept: 'application/json',
        },
        timeout: 15000,
      }
    );

    const { data } = response;

    if (data.status === 0) {
      const token = {
        access_token: data.token,
        expires_at: Date.now() + 30 * 60 * 1000, // 30 minutes
      };
      saveTaxAccToken(token);
      return { state: true, token: token.access_token };
    }

    return { state: false, message: data.message || 'Token refresh failed' };
  } catch (error) {
    console.error('TaxAcc token refresh failed:', error);

    if (error.response) {
      console.error('Status:', error.response.status);
      console.error('Data:', error.response.data);
    } else if (error.request) {
      console.error('No response - likely CORS or network block');
    }

    const msg =
      error?.response?.data?.message ||
      error.message ||
      'Сүлжээний алдаа эсвэл CORS хориг';
    return { state: false, message: msg };
  }
}

const actionKeyDict = {
  avlag_uglug: { url: 'save_journal', method: 'POST', journal_type: 1 },
  guilgee: { url: 'save_journal', method: 'POST', journal_type: 2 },
  undsen_hurungu: { url: 'save_journal', method: 'POST', journal_type: 3 },
};

export default async function taxAccApi(actionKey, data = [], params = {}) {
  let token = getTaxAccToken();

  if (!token || isTokenExpired(token)) {
    const refreshResult = await refreshTokenUsingJwt();
    if (!refreshResult.state) {
      return refreshResult;
    }
    token = getTaxAccToken();
  }

  const action = actionKeyDict[actionKey];
  if (!action) {
    return { state: false, message: 'Unknown action' };
  }

  try {
    const url = `${TAX_ACC_API_URL}/${action.url}?journal_type=${action.journal_type}`;

    const response = await axios({
      url,
      method: action.method,
      headers: {
        Authorization: `Bearer ${token.access_token}`,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      data, // Your transformed array
      timeout: 30000,
    });

    const responseData = response.data;

    if (responseData.status === 0) {
      return {
        state: true,
        message: responseData.message || 'Амжилттай хадгалагдлаа',
      };
    }

    return { state: false, message: responseData.message || 'Алдаа гарлаа' };
  } catch (error) {
    console.error('TaxAcc API Error:', error);

    if (error.response?.status === 401) {
      clearTaxAccToken();
      const retry = await refreshTokenUsingJwt();
      if (retry.state) {
        return taxAccApi(actionKey, data, params); // retry once
      }
      return { state: false, message: 'Токен хүчингүй болсон' };
    }
    if (error.response?.status === 429) {
      const msg =
        error?.response?.data?.message ||
        error.message ||
        'Хэт их хүсэлт илгээгдлээ';
      return { state: false, message: msg };
    }

    const msg =
      error?.response?.data?.message || error.message || 'Сүлжээний алдаа';
    return { state: false, message: msg };
  }
}
